import { RUNTIME_URI } from '../../../constants/platform';
import { DEFAULT_THEME_NAME } from '../../../constants/themes';
import type { Environment } from '../../../types/environment';
import type { FlowResponseAPI, ReleasedSnapshot } from '../../../types/flow';
import { useTenant } from '../../TenantProvider';
import { getVersionId } from './utils';

interface Props {
    environments: Environment[];
    flowId: string;
    snapshot: ReleasedSnapshot | FlowResponseAPI;
}

const HistoryRunButton = ({ environments, flowId, snapshot }: Props) => {
    const tenant = useTenant();

    let url = '';

    const versionId = getVersionId(snapshot);
    const versionIdParam = `&flow-version-id=${versionId}`;

    if (environments?.length > 0) {
        const releasedSnapshot = snapshot as ReleasedSnapshot;
        const snapshotEnvironment = environments.find(
            (e) => e.id === releasedSnapshot.environmentId,
        );
        if (!snapshotEnvironment) {
            throw new Error('No environment found');
        }

        if (!tenant.tenantSettings?.themes) {
            url = `${RUNTIME_URI}/${tenant.id}/play/${snapshotEnvironment.defaultPlayerName}?flow-id=${flowId}&environment-id=${snapshotEnvironment.id}${versionIdParam}`;
        } else if (tenant?.tenantSettings?.themes) {
            url = `${RUNTIME_URI}/${tenant.id}/play/theme/${snapshotEnvironment.defaultThemeName}?flow-id=${flowId}&environment-id=${snapshotEnvironment.id}${versionIdParam}`;
        }
    } else if (tenant.tenantSettings?.themes) {
        url = `${RUNTIME_URI}/${tenant.id}/play/theme/${DEFAULT_THEME_NAME}?flow-id=${flowId}${versionIdParam}`;
    } else {
        url = `${RUNTIME_URI}/${tenant.id}/play/${DEFAULT_THEME_NAME}?flow-id=${flowId}${versionIdParam}`;
    }

    return (
        <a className="btn btn-primary" href={url} target="_blank" rel="noopener noreferrer">
            Run Flow
        </a>
    );
};

export default HistoryRunButton;
